// @ts-check
import { useQuery } from '@tanstack/react-query';
import api from 'modules/queries/api';
import accountStatuses from 'utility/constants/accountStatuses';

/**
 * @param {import('club-sauce/public/account/index.raw').LWApiPublicAccountDetailsParamsRawI} params
 * @param {object} [options]
 * @param {import('@tanstack/react-query').UseQueryOptions['enabled']} [options.enabled]
 * @param {import('@tanstack/react-query').UseQueryOptions['retry']} [options.retry]
 * @param {number} [options.refetchInterval]
 */

const useAccountDetails = (params, options) => {
	return useQuery({
		queryKey: ['/account/details', params],
		queryFn: () => api.account.apiRaw.details(params),
		enabled: options?.enabled,
		retry: options?.retry,
	});
};

/**
 * @param {import('club-sauce/public/account/index.raw').LWApiPublicAccountDetailsParamsRawI} params
 * @param {object} [options]
 * @param {import('@tanstack/react-query').UseQueryOptions['enabled']} [options.enabled]
 * @param {import('@tanstack/react-query').UseQueryOptions['retry']} [options.retry]
 * @param {number} [options.refetchInterval]
 */
export const useAccountDetailsWithEverything = (params, options) =>
	useAccountDetails(
		{
			...params,
			alsowith: [
				...(typeof params?.alsowith === 'string'
					? [params?.alsowith]
					: params?.alsowith || []),
				'businessUnit',
				'customerLifecycle',
				'highlights',
				'managementPortal',
				'referAFriend',
			],
		},
		{
			enabled: options?.enabled,
			retry: options?.retry,
			refetchInterval: options?.refetchInterval,
		},
	);

/**
 * @param {import('club-sauce/public/account/index.raw').LWApiPublicAccountDetailsParamsRawI} params
 * @param {object} [options]
 * @param {import('@tanstack/react-query').UseQueryOptions['enabled'] | undefined} [options.enabled]
 * @param {import('@tanstack/react-query').UseQueryOptions['retry'] | undefined} [options.retry]
 */

export const usePollPendingNewAccountDetails = (params, options) => {
	return useQuery({
		queryKey: ['/account/details', params],
		queryFn: () => api.account.apiRaw.details(params),
		enabled: options?.enabled,
		retry: options?.retry,
		refetchInterval: (data) => {
			if (data?.account_status === accountStatuses.PENDING_NEW) {
				return 10000;
			}
			return false;
		},
	});
};

export default useAccountDetails;
